import React, {Component} from 'react'
import {BrowserRouter as Router, Switch, Route, withRouter} from 'react-router-dom'
import {
    MDBContainer,
} from "mdbreact";
import LoginPage from '../LoginPage/LoginPage'
import ViewPost from "../ViewPost/ViewPost";
import Heading from "../Homepage/Heading/Heading";
import * as firebase from "firebase";
import classes from './RouterManager.module.css'
import FormRegistration from '../FormRegistration/FormRegistration'
import NewPost from "../NewPost/NewPost";
import HomePage from "../Homepage/Main/HomgPage/HomePage";
import MemberRegistration from "../MemberRegistration/MemberRegistration"
import AdminLayout from "../../ManagementSystem/Admin/AdminLayout";
import NewArticle from "../NewArticle/NewArticle";
import ViewArticle from "../ViewArticle/ViewArticle"
import {connect} from "react-redux";
import {faArrowLeft, faFileAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import common from "../../Utils/common.module.css";
import MemberLayout from "../../ManagementSystem/Member/MemberLayout";
import EmailVerification from "../EmailVerification/EmailVerification";
import TestIndex from "../../TEST_LAB";

const AdminOnly = (ComposedComponent, auth) => {
    class AdminOnly extends Component {
        constructor(props) {
            super(props);
            this.state = {
                isPass: false
            }
        }

        componentWillMount() {
            if (!auth.isEmpty) {
                firebase.auth().currentUser.getIdTokenResult()
                    .then((idTokenResult) => {
                        if (idTokenResult.claims.type === "administrator") {
                            this.setState({
                                isPass: true
                            })
                        } else {
                            this.props.history.push('/login')
                        }
                    })
            } else {
                this.setState({
                    isPass: false
                })
                this.props.history.push('/login')
            }
        }

        render() {
            if (this.state.isPass) {
                return <ComposedComponent location={this.props.location} history={this.props.history}
                                          auth={this.props.auth}/>
            } else {
                return (
                    <div>
                        Checking...
                    </div>
                )
            }
        }
    }

    return AdminOnly
}

class RouterManager extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div>
                <Heading/>
                {
                    this.props.auth.isLoaded ?
                        <div className={classes.MainContainer}>
                            {
                                this.props.location.pathname !== '/' ?
                                    <button className={common.BackBtnFixed}
                                            onClick={(e) => {
                                                this.props.history.goBack()
                                            }}
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft}/>

                                    </button>
                                    : ''
                            }
                            <Switch>
                                <Route path="/login" exact>
                                    <LoginPage/>
                                </Route>
                                <Route path="/post/:id">
                                    <ViewPost/>
                                </Route>>
                                <Route path="/new-post">
                                    <NewPost/>
                                </Route>
                                <Route path="/article/:id">
                                    <ViewArticle/>
                                </Route>
                                <Route path="/m">
                                    <MemberLayout/>
                                </Route>
                                <Route path="/admin" component={AdminOnly(AdminLayout, this.props.auth)}>
                                </Route>
                                <Route path="/MemberRegistration">
                                    <MemberRegistration/>
                                </Route>
                                <Route path="/verify/:vid">
                                    <EmailVerification/>
                                </Route>
                                <Route path="/">
                                    <HomePage/>
                                </Route>
                            </Switch>
                        </div>
                        : ''
                }
            </div>
        );
    }
}


const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(RouterManager))